import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../../../config/api";
import { Button } from "@mui/material";
import { FcLike, FcLikePlaceholder } from "react-icons/fc";
import {toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const HomeProductCard = ({ product, link, wishlist }) => {
  const navigate = useNavigate();
  const productId = product.product._id;

  // Check if the product is already in the wishlist
  const [like, setLike] = useState(
    wishlist.some((item) => item._id === productId)
  );

  const toggleLike = async () => {
    const token = localStorage.getItem("jwt");

    if (!token) {
          toast.error("Please log in to add item into wishlist");
      return;
    }

    try {
      if (like) {
        await api.delete(`/api/wishlist/delete/${productId}`);
      } else {
        await api.post(`/api/wishlist/add/${productId}`);
      }
      setLike(!like); // Toggle the like status
    } catch (error) {
       if(error.status==400){
            toast.error(error.response.data.message);
          }
    }
  };

  return (
    <div className="m-15 cursor-pointer h-[40vh] flex flex-col items-center bg-white rounded-lg shadow-lg overflow-hidden w-[90%] md:w-[80%] mx-3">
      <div className="h-[70%]">
        <Link to={`product/${product._id || product.product?._id}`}>
          <div className=" w-auto h-[100%]">
            <img
              className="object-cover object-top w-full h-full"
              src={
                product?.image || product?.imageUrl || product.product?.imageUrl
              }
              alt={product?.title}
            />
          </div>
        </Link>
      </div>
      <div className="flex h-[30%] justify-between items-center w-[100%]">
        <Button onClick={toggleLike} className="wishlist-btn">
          <span role="img" aria-label="Wishlist">
            {like ? (
              <FcLike className="text-2xl" />
            ) : (
              <FcLikePlaceholder className="text-2xl" />
            )}
          </span>
        </Button>

        <div className="p-4">
          <h3 className="text-sm md:text-lg font-medium">
            {product?.brand || product?.title || product.product?.title}
          </h3>
          <p className="mt-2 text-xs md:text-sm">
            {product?.title || product.product?.title} {product?.URI}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HomeProductCard;
